import axios from 'axios'
import i18n from '@/plugins/i18n'

export default {
  // Создание
  create (id, data) {
    return axios.post(`${i18n.locale}/api/oopt_observer/create/${id}`, data)
  },
  // Получение данных для редактирования
  getEdit (id) {
    return axios.get(`${i18n.locale}/api/oopt_observer/get/${id}`, id)
  },
  // Список
  list (id) {
    return axios.get(`${i18n.locale}/api/oopt_observer/list/${id}`)
  },
  // Получение всех наблюдателей кроме текущего ООПТ
  getOtherObservers (id) {
    return axios.get(`${i18n.locale}/api/oopt_observer/otherObservers/${id}`, id)
  },
  // Добавление существующего наблюдателя к ООПТ
  addToOopt (id, ooptId) {
    return axios.get(`${i18n.locale}/api/oopt_observer/addToOopt/${id}/${ooptId}`)
  },
  // Установка актиный/неактивный
  setActive (id) {
    return axios.get(`${i18n.locale}/api/oopt_observer/public/${id}`)
  }
}
